<template>
	<Transition
		name="fly"
	>
		<div
			v-if="isShown"
			class="demo-mode-notify"
			:class="{'demo-mode-notify--hidden': !isShown}"
		>
			Demo mode
		</div>
	</Transition>
</template>

<script>
import { computed, ref, watch } from 'vue';

const TIMER_DURATION = 1000;

export default {
	name: 'DemoNotify',
	props: {
		timeStamp: {
			type: Number,
			required: true,
		},
	},
	setup(props) {
		const lastTimeStamp = computed(() => props.timeStamp);
		let timer = null;
		const isShown = ref(false);

		watch(lastTimeStamp, (value) => {
			if (value === 0) {
				isShown.value = false;
				return;
			}
			if (timer) {
				clearTimeout(timer);
			}
			isShown.value = true;
			timer = setTimeout(() => {
				isShown.value = false;
			}, TIMER_DURATION);
		});

		return {
			isShown,
		};
	},
};
</script>

<style lang="sass" scoped>
.demo-mode-notify
	position: absolute
	left: 50%
	top: 50%
	transform: translate(-50%, -50%)

	font-size: 20px

	padding: 16px 28px

	color: #ffffff
	background: rgba(0, 0, 0, 0.7)
	border-radius: 100px

	opacity: 1

.fly-enter-active,
.fly-leave-active
	transition: opacity 0.2s

.fly-enter-from,
.fly-leave-to
	opacity: 0
</style>
